import { __awaiter, __generator } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FaGoogle } from 'react-icons/fa';
import { FiMail } from 'react-icons/fi';
import { Button, Container, FormContainer, SmallText, SubTitle, Title } from './login.styles';
import { Link } from 'react-router-dom';
import endpoints from '../../services/endpoints';
import { useLoadingActions } from '../../context&providers/providers/Loading';
var LoginForm = function (_a) {
    var handleEmailLoginClick = _a.handleEmailLoginClick;
    var _b = useLoadingActions(), showLoading = _b.showLoading, hideLoading = _b.hideLoading;
    var handleOAuth = function (provider) { return __awaiter(void 0, void 0, void 0, function () {
        var oauthWindow, messageListener;
        return __generator(this, function (_a) {
            showLoading();
            oauthWindow = window.open(endpoints.api[provider], "_blank");
            if (!oauthWindow) {
                hideLoading();
                alert("Popup blocked! Please allow popups and try again.");
                return [2 /*return*/];
            }
            messageListener = function (event) {
                //if (event.origin !== window.location.origin) return; // Ensure the message is from the same origin
                if (event.data === "oauth:success") {
                    hideLoading(); // Hide loader when OAuth is completed
                    window.removeEventListener("message", messageListener); // Cleanup listener
                    // Redirect or handle post-login logic
                    window.location.href = endpoints.web.home; // Example redirection
                }
            };
            window.addEventListener("message", messageListener);
            // Fallback to hide loader after a timeout (in case of errors)
            setTimeout(function () {
                hideLoading();
                window.removeEventListener("message", messageListener); // Cleanup listener
            }, 30000); // Adjust timeout as needed
            return [2 /*return*/];
        });
    }); };
    return (_jsx(Container, { children: _jsxs(FormContainer, { children: [_jsx(Title, { children: "Log in or sign up in seconds" }), _jsx(SubTitle, { children: "Use your email or another service to continue (it\u2019s free!)" }), _jsxs(Button, { onClick: function () { return handleOAuth("googleOAuth"); }, children: [_jsx(FaGoogle, { size: 20 }), "Continue with Google"] }), _jsxs(Button, { onClick: handleEmailLoginClick, children: [_jsx(FiMail, { size: 20 }), "Continue with email"] }), _jsxs(SmallText, { children: ["By continuing, you agree to CorpTrip's ", _jsx(Link, { to: "#", children: "Terms of Use" }), " and ", _jsx(Link, { to: "#", children: "Privacy Policy" }), "."] })] }) }));
};
export default LoginForm;
